import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

import RefreshIcon from '@mui/icons-material/Refresh';
import { IconButton } from "@mui/material";
import Summary from 'Components/Summary';

//Actions
import { simInfoRequest, clearRedux } from 'Redux/actions';
import { Loading, Tooltip } from "@gpstrackit/react-controls";
//Styles
import './index.scss';

const SimInfo = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const { iccid, height } = props;

    const { loading, result } = useSelector(state => state.simInfoRedux);
    const [details, setDetails] = useState(null);

    const changeStatusUnit = useSelector(state => state.changeStatusRedux.result);

    const getData = () => {
        dispatch(simInfoRequest(iccid))
    }

    useEffect(() => {
        if (result) {
            try {
                let currentDetails = JSON.parse(result);
                setDetails(currentDetails)
            } catch (error) {
                setDetails({ error: true })
            }
        }
    }, [result])

    useEffect(() => {
        if(changeStatusUnit && changeStatusUnit?.update){
            getData();
        }
    },[changeStatusUnit])

    useEffect(() => {
        getData();
        return () => {
            setDetails(null);
            dispatch(clearRedux("SIM_INFO_TAB"));
        }
    }, [])

    return (
        <div className="sim-info-container" style={{ height: height, overflow: 'auto' }}>
            {loading && <Loading overlay show />}
            {
                details?.error
                    ?
                    <div className="error-container"><p>{messages['common_no_information_to_display']}</p></div>
                    :
                    <>
                        <Tooltip title={messages['refresh']}>
                            <IconButton onClick={() => getData()} size="large">
                                <RefreshIcon style={{ color: 'black', fontSize: 20 }} />
                            </IconButton>
                        </Tooltip>
                        {details &&
                            <div style={{ padding: '5px 14px' }}>
                                <Summary data={details} columns={4} addDash noSort />
                            </div>
                        }
                    </>
            }
        </div>
    );
}

export default SimInfo;